(function (){
    'use strict';

    angular
        .module('services')
        .service('ClientService', ClientService);

    ClientService.$inject = ['$http', 'API_BASE'];

    function ClientService($http, API_BASE) {
        
        var service = this;
        
        service.getClientCredits    = getClientCredits;
        service.deleteClientCredit  = deleteClientCredit;
        service.useClientCredit     = useClientCredit;
        service.listClients         = listClients;
        service.storeCredit         = storeCredit;
        service.updateCredit        = updateCredit;

        function getClientCredits (query) {
            return $http.get(API_BASE + '/users/credits', { params: query });
        }

        function deleteClientCredit (id) {
            return $http.delete(API_BASE + '/users/credits/' + id);
        }

        function useClientCredit (id, data) {
            return $http.put(API_BASE + '/users/credits/' + id, data);
        }

        function listClients (data) {
            return $http.get(API_BASE + '/users/list', { params: data });
        }

        function storeCredit (data) {
            return $http.post(API_BASE + '/users/credits', data);
        }

        function storeCredit (data) {
            return $http.post(API_BASE + '/users/credits', data);
        }

        function updateCredit (id, data) {
            return $http.put(API_BASE + '/users/credits/' + id, data);
        }
    }
})();